import { createFileRoute } from '@tanstack/react-router';

import { SupplierPortalPage } from '../../components/SupplierPortalPage';

export const Route = createFileRoute('/vendor/$token')({
  component: SupplierPortalPage,
});
